import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    explore: [
      { label: 'EES Centers', href: '/wellness-center-listings?type=ees-center' },
      { label: 'Meditation Retreats', href: '/wellness-center-listings?type=meditation' },
      { label: 'Spa Resorts', href: '/wellness-center-listings?type=spa' },
      { label: 'Yoga Retreats', href: '/wellness-center-listings?type=yoga' },
      { label: 'Detox Programs', href: '/wellness-center-listings?type=detox' }
    ],
    support: [
      { label: 'Help Center', href: '/help' },
      { label: 'Safety Guidelines', href: '/safety' },
      { label: 'Cancellation Policy', href: '/cancellation' },
      { label: 'Community Guidelines', href: '/community' },
      { label: 'Contact Us', href: '/contact' }
    ],
    hosting: [
      { label: 'List Your Center', href: '/become-partner' },
      { label: 'Partner Resources', href: '/partner-resources' },
      { label: 'Community Standards', href: '/standards' },
      { label: 'Marketing Tools', href: '/marketing-tools' },
      { label: 'Partner Support', href: '/partner-support' }
    ],
    about: [
      { label: 'Our Mission', href: '/about' },
      { label: 'Careers', href: '/careers' },
      { label: 'Press & Media', href: '/press' },
      { label: 'Investors', href: '/investors' },
      { label: 'Blog', href: '/blog' }
    ]
  };

  return (
    <footer className="bg-gradient-to-b from-background-light to-surface border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <Link to="/wellness-retreat-homepage" className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-gradient-to-r from-primary to-accent rounded-lg
                               flex items-center justify-center">
                <Icon name="Sparkles" size={24} color="white" />
              </div>
              <span className="text-2xl font-bold text-text-primary font-heading">
                WellnessHub
              </span>
            </Link>
            <p className="text-sm text-text-secondary mb-6 leading-relaxed">
              Discover transformative wellness experiences at certified EES centers,
              meditation retreats, and healing sanctuaries worldwide.
            </p>

            {/* Social Links */}
            <div className="flex space-x-4">
              {[
                { name: 'Facebook', icon: 'Facebook' },
                { name: 'Instagram', icon: 'Instagram' },
                { name: 'Twitter', icon: 'Twitter' },
                { name: 'YouTube', icon: 'Youtube' }
              ].map((social) => (
                <a
                  key={social.name}
                  href={`https://${social.name.toLowerCase()}.com/wellnesshub`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 bg-white border border-border rounded-lg flex items-center
                             justify-center hover:bg-background-light hover:border-border-focus transition-all
                             duration-200 micro-interaction"
                  aria-label={`Follow us on ${social.name}`}
                >
                  <Icon name={social.icon} size={18} className="text-text-secondary" />
                </a>
              ))}
            </div>
          </div>

          {/* Links Sections */}
          <div className="lg:col-span-4 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-sm font-semibold text-text-primary uppercase tracking-wide mb-4">
                Explore
              </h3>
              <ul className="space-y-3">
                {footerLinks.explore.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-text-secondary hover:text-text-primary transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-text-primary uppercase tracking-wide mb-4">
                Support
              </h3>
              <ul className="space-y-3">
                {footerLinks.support.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-text-secondary hover:text-text-primary transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-text-primary uppercase tracking-wide mb-4">
                Hosting
              </h3>
              <ul className="space-y-3">
                {footerLinks.hosting.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-text-secondary hover:text-text-primary transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-text-primary uppercase tracking-wide mb-4">
                About
              </h3>
              <ul className="space-y-3">
                {footerLinks.about.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-text-secondary hover:text-text-primary transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="bg-gradient-to-r from-background-light to-background-medium rounded-2xl p-8 mb-8">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="text-2xl font-bold text-text-primary mb-2 font-heading">
              Stay Connected to Your Wellness Journey
            </h3>
            <p className="text-text-secondary mb-6">
              Get exclusive access to new centers, wellness tips, and special offers
            </p>
            <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 border border-border rounded-lg focus:border-primary
                           focus:ring-2 focus:ring-background-medium transition-all duration-200"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-gradient-to-r from-primary to-secondary text-white
                           font-semibold rounded-lg hover:from-secondary hover:to-primary
                           transition-all duration-200 micro-interaction whitespace-nowrap"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-6 text-sm text-text-secondary">
              <span>© {currentYear} WellnessHub. All rights reserved.</span>
              <Link
                to="/privacy"
                className="hover:text-text-primary transition-colors duration-200"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="hover:text-text-primary transition-colors duration-200"
              >
                Terms of Service
              </Link>
            </div>

            <div className="flex items-center space-x-4">
              <span className="text-sm text-text-secondary">Available in:</span>
              <select className="text-sm text-text-secondary bg-transparent border border-border
                                 rounded-md px-2 py-1 hover:bg-surface focus:border-primary
                                 focus:ring-1 focus:ring-background-medium transition-all duration-200">
                <option value="en">English</option>
                <option value="es">Español</option>
                <option value="fr">Français</option>
                <option value="de">Deutsch</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
